<div class="container-fluid py-5 h-100">
  <div class="row justify-content-center align-items-center h-100">
    <div class="col-md-6 col-lg-4">
      <div class="card shadow">
        <div class="card-body text-center py-5">

          <!-- Processing State -->
          <div *ngIf="processing && !error">
            <div class="spinner-border text-primary mb-4" role="status" style="width: 3rem; height: 3rem;">
              <span class="visually-hidden">Loading...</span>
            </div>
            <h4 class="text-muted mb-3">Completing sign-in...</h4>
            <p class="text-muted">Please wait while we verify your credentials.</p>
          </div>

          <!-- Error State -->
          <div *ngIf="error">
            <div class="text-danger mb-3" style="font-size: 64px;">
              <i class="fas fa-exclamation-circle"></i>
            </div>
            <h4 class="text-danger mb-3">Authentication Failed</h4>
            <p class="text-muted">{{ error }}</p>
            <p class="text-muted small">Redirecting to home page...</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
